import BaseAPI from './base.api.service'

const resource = 'meals';
export default {
    async get(erID) {
        return await BaseAPI.get(`expensereports/${erID}/meals`);
    },
    async save(request) {
        return await BaseAPI.put(`${resource}/`, request)
    },
    async delete(erID) {
        return await BaseAPI.delete(`${resource}/${erID}`)
    },
    async deleteException(exceptionID) {
        return await BaseAPI.delete(`ExpenseExceptions/${exceptionID}`)
    }
} 